import React from 'react';

import {
  Campaign,
  CampaignInventory,
  Character,
  CharacterInventory,
} from "@dndModels";

import CurrencyEditor from "@dndComponents/character/inventory/CurrencyEditor";

interface Props {
  char: Character | Campaign;
  inventory: CharacterInventory | CampaignInventory;
}

export default function CharacterCurrency({
  char,
  inventory
}: Props) {
  return (
    <CurrencyEditor
      money={inventory.money}
      onChange={() => {
        char.changed();
        char.subscription_holder.itemsChanged();
      }}
    />
  );
}
